define(["jquery"], function($) {
    $(document).ready(function() {
        showComments();

        function showComments(){
            let url = $(location).attr('href');
            let a = $('<a>', { href: url });
            if (a.prop('hash') == '#comments'){
                let button = $(".ue-c-article__old-comments").find(":button:first");
                if (typeof button !== "undefined"){
                    button.click();
                }
            }
        }
    });
});
